import { __exports as vatHelper } from './_virtual-vatHelper.js';
import { __require as requireEs_string_replace } from './node_modules-core-js-modules-es.string.replace.js';
import { __require as requireContainer } from './vp-js-token-engine-build-infrastructure-container.js';
import { __require as requireLocalizations } from './vp-js-token-engine-build-infrastructure-localizations.js';
import { __require as requireUrl } from './vp-js-token-engine-build-common-url.js';

var hasRequiredVatHelper;

function requireVatHelper () {
	if (hasRequiredVatHelper) return vatHelper;
	hasRequiredVatHelper = 1;

	Object.defineProperty(vatHelper, "__esModule", {
	  value: true
	});
	vatHelper.getVatHtml = getVatHtml;
	vatHelper.getVatText = getVatText;
	requireEs_string_replace();
	var _container = requireContainer();
	var _localizations = requireLocalizations();
	var _url = requireUrl();
	const VAT_MESSAGE_TEMPLATE = "<span class='swan-short-tax-message'>{{vatText}}</span>";
	const VAT_MESSAGE_WITH_SHIPPING_TEMPLATE = "<span class='swan-short-tax-message'>{{vatTextWithShipping}}</span>";
	function getVatText(vatInc, culture) {
	  const vatText = vatInc ? 'vatInc' : 'vatEx';
	  if (isDisableVatMessageIn(culture)) {
	    return '';
	  }
	  return (0, _localizations.localized)(vatText, culture);
	}
	async function getVatHtml(vatInc, culture, hideShippingMessageInVatMessage, scope) {
	  if (isDisableVatMessageIn(culture)) {
	    return '';
	  }
	  if (isShippingMessageEnabledPerCulture(culture) && !hideShippingMessageInVatMessage) {
	    const vatMessageWithShippingHtml = await getVatWithShippingHtml(vatInc, culture, scope);
	    return vatMessageWithShippingHtml;
	  }
	  const mustacheVariables = {
	    vatText: getVatText(vatInc, culture)
	  };
	  return _container.mustacheService.replace(VAT_MESSAGE_TEMPLATE, mustacheVariables);
	}
	async function getVatWithShippingHtml(vatInc, culture, scope) {
	  const shippingMessage = await getShippingMessageHtml(culture, scope);
	  const mustacheVariables = {
	    vatTextWithShipping: getVatTextWithShipping(vatInc, culture),
	    shippingMessage
	  };
	  return _container.mustacheService.replace(VAT_MESSAGE_WITH_SHIPPING_TEMPLATE, mustacheVariables);
	}
	async function getShippingMessageHtml(culture, scope) {
	  var _scope$context;
	  const shippingMessage = (0, _localizations.localized)('shippingMessage', culture);
	  const shippingUrl = (0, _url.getShippingUrl)(scope);
	  const SHIPPING_MESSAGE_TEMPLATE = (_scope$context = scope.context) !== null && _scope$context !== void 0 && (_scope$context = _scope$context.environments) !== null && _scope$context !== void 0 && _scope$context.isTile ? "<span class='swan-standard-tile-separately-clickable-contents'><a target='_blank' href='".concat(shippingUrl, "'>{{shippingMessage}}</a></span>") : "<a target='_blank' href='".concat(shippingUrl, "'>{{shippingMessage}}</a>");
	  return _container.mustacheService.replace(SHIPPING_MESSAGE_TEMPLATE, {
	    shippingMessage
	  });
	}
	function getVatTextWithShipping(vatInc, culture) {
	  const vatTextWithShipping = vatInc ? 'vatIncWithShipping' : 'vatExWithShipping';
	  if (isDisableVatMessageIn(culture)) {
	    return '';
	  }
	  return (0, _localizations.localized)(vatTextWithShipping, culture);
	}
	const disableVatMessagePerCulture = {
	  'en-in': true,
	  'en-au': true,
	  'en-sg': true,
	  'en-nz': true,
	  'en-jp': true,
	  'ja-jp': true,
	  'en-us': true,
	  'es-us': true,
	  'en-ca': true,
	  'fr-ca': true
	};
	function isDisableVatMessageIn(culture) {
	  const formattedCulture = culture.replace('_', '-').toLowerCase();
	  return disableVatMessagePerCulture[formattedCulture] ? disableVatMessagePerCulture[formattedCulture] : false;
	}
	const enableShippingMessagePerCulture = {
	  'de-de': true
	};
	function isShippingMessageEnabledPerCulture(culture) {
	  const formattedCulture = culture.replace('_', '-').toLowerCase();
	  return enableShippingMessagePerCulture[formattedCulture] ? enableShippingMessagePerCulture[formattedCulture] : false;
	}
	
	return vatHelper;
}

export { requireVatHelper as __require };
//# sourceMappingURL=vp-js-token-engine-build-common-vatHelper.js.map
